import styles from './pop-out-player-overlay.module.scss';
import classNames from 'classnames';
import noop from 'lodash/noop';

export type PopOutPlayerOverlayProps = {
  onOverlayClick?: () => void;
  onCloseClick?: () => void;
  onFullScreenClick?: () => void;
  onClosePopOutClick?: () => void;
  isPlaying: boolean;
  showPopOutButton: boolean;
};

export const PopOutPlayerOverlay = ({
  onOverlayClick = noop,
  onCloseClick = noop,
  onFullScreenClick = noop,
  onClosePopOutClick = noop,
  isPlaying = false,
  showPopOutButton,
}: PopOutPlayerOverlayProps) => (
  <div
    onClick={() => {
      onOverlayClick();
    }}
    data-hook='pop-out-overlay'
    className={styles['pop-out-overlay']}
  >
    <button
      data-hook='pop-out-play-toggle'
      aria-label={polyglot.t(`video_player.${isPlaying ? 'pause' : 'play'}`)}
      className={classNames(
        styles['pop-out-overlay__primary-icon'],
        styles[
          `pop-out-overlay__primary-icon--${isPlaying ? 'pause' : 'play'}`
        ],
      )}
    />
    {showPopOutButton && (
      <button
        data-hook='pop-out-unpop-player'
        aria-label={polyglot.t('video_player.unpop_player')}
        onClick={(evt: React.MouseEvent<HTMLButtonElement>) => {
          evt.stopPropagation();
          onClosePopOutClick();
        }}
        className={classNames(
          styles['pop-out-overlay__secondary-icon'],
          styles['pop-out-overlay__secondary-icon--top-left'],
          styles['pop-out-overlay__secondary-icon--close-pop-out'],
        )}
      />
    )}
    <button
      data-hook='pop-out-close'
      aria-label={polyglot.t('video_player.stop_pop_out')}
      onClick={(evt: React.MouseEvent<HTMLButtonElement>) => {
        evt.stopPropagation();
        onCloseClick();
      }}
      className={classNames(
        styles['pop-out-overlay__secondary-icon'],
        styles['pop-out-overlay__secondary-icon--top-right'],
        styles['pop-out-overlay__secondary-icon--close'],
      )}
    />
    <button
      data-hook='pop-out-fullscreen'
      aria-label={polyglot.t('video_player.fullscreen')}
      onClick={(evt: React.MouseEvent<HTMLButtonElement>) => {
        evt.stopPropagation();
        onFullScreenClick();
      }}
      className={classNames(
        styles['pop-out-overlay__secondary-icon'],
        styles['pop-out-overlay__secondary-icon--bottom-right'],
        styles['pop-out-overlay__secondary-icon--fullscreen'],
      )}
    />
  </div>
);
